import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import {
  Form as BaseForm,
  TextField,
  TextAreaField,
  SelectField,
  SubmitButton,
  CancelPopupButton,
} from '../../ui/FormElement';
import routes from '../../app/routes';

export default function Form({
  closeForm,
  workType,
  coachName,
  programName,
  programId,
  memberName,
  coachingPlanId,
  actionPlanId,
  updateCollection,
  formDescription,
  formStudentId,
  formSuggestCoachId,
  formChangeCoachRequestId,
  formStatus,
  workMode = 'create',
}) {
  let FormSchema;
  if (workType == 'AdminChangeMember' && workMode == 'create') {
    FormSchema = Yup.object().shape({
      description: Yup.string().required('Reason is required'),
      programs: Yup.string().typeError('Please, choose Program'),
      members: Yup.number().typeError('Please, choose Member'),
    });
  } else if (workType == 'AdminChangeCoach' && workMode == 'create') {
    FormSchema = Yup.object().shape({
      description: Yup.string().required('Reason is required'),
      coach: Yup.number().typeError('Please, choose Coach'),
    });
  } else {
    FormSchema = Yup.object().shape({
      description: Yup.string().required('Reason is required'),
    });
  }

  const [formData, setFormData] = useState({
    description: formDescription,
    programs: null,
    members: null,
    coach: null,
    suggest_coach: formSuggestCoachId,
    current_member: memberName,
    current_coach: coachName,
    program_name: programName,
    member_name_all: 'All',
  });

  const [members, setMembers] = useState();
  const [programs, setPrograms] = useState();
  const [coaches, setCoaches] = useState();
  const [suggestCoaches, setSuggestCoaches] = useState();
  const [formSuggestValue, setFormSuggestValue] = useState();

  const programSelect = useRef(null);
  const suggestedCoachSelect = useRef(null);

  const onSubmit = (values, { setSubmitting, resetForm, setStatus }) => {
    setSubmitting(true);
    if (workMode == 'create') {
      axios
        .post(routes.api.change_coach_requests.create, {
          ...values,
          workType,
          coachingPlanId,
          actionPlanId,
        })
        .then((resp) => {
          closeForm();
          if (updateCollection != undefined) {
            updateCollection();
          }
          if (workType === 'CoachingPlanChangeCoach') {
            swal({
              title: 'Your coach change request was successfully submitted.',
              text:
                'We will notify you as soon as your request was approved and you can select your new coach. Please contact your Success Manager via the support chat widget if you have any additional questions.',
            });
          } else {
            swal('Request sent!');
          }
        })
        .catch((error, data) => {
          swal(error.response.data.error);
        });
    } else {
      axios
        .put(
          routes.api.change_coach_requests.update(formChangeCoachRequestId),
          {
            ...values,
            workType,
          },
        )
        .then((resp) => {
          closeForm();
          if (updateCollection != undefined) {
            updateCollection();
          }
          swal('Request updated!');
        });
    }
  };

  const memberSearch = (value) => {
    if (value.length >= 3) {
      axios
        .post(routes.api.students.list, {
          q: { full_name_matches: `%${value}%` },
        })
        .then((resp) => {
          setMembers(resp.data);
        });
    }
  };

  const getSuggestedCoach = (value) => {
    if (value == null) {
      suggestedCoachSelect.current.select.clearValue();
      return;
    }

    const data = {};
    if (formData != undefined && formData.suggest_coach != undefined) {
      data.coach_id = formData.suggest_coach;
    }

    axios
      .get(routes.api.students.match_coach(value), { params: data })
      .then((resp) => {
        suggestedCoachSelect.current.select.clearValue();
        setSuggestCoaches(resp.data);
        const value = resp.data.filter(
          (option) => option.value === formSuggestCoachId,
        );

        setFormSuggestValue(value[0]);
        suggestedCoachSelect.current.select.setValue(value[0]);
      });
  };

  const programSearch = (value) => {
    if (value == null) {
      programSelect.current.select.clearValue();
      return;
    }
    axios.post(routes.api.coaching_plans.list, {
      q: { student_id_eq: value },
    }).then((response) => {
      const values = response.data.data.map((item) => ({
        value: `CoachingPlan_${item.id}`,
        label: item.attributes.title,
      }));

      programSelect.current.select.clearValue();
      setPrograms(values);
    });
  };

  const suggestedCoachSearch = (value) => {
    getSuggestedCoach(value);
  };

  const coachSearch = (value) => {
    if (value.length >= 3) {
      axios
        .post(routes.api.coaches.list, {
          q: { full_name_matches: `%${value}%` },
        })
        .then((resp) => {
          setCoaches(resp.data);
        });
    }
  };

  const blockField = () => {
    if (formStatus == null || formStatus == undefined) {
      return false;
    }

    return (
      formStatus === 'accepted'
      || formStatus === 'declined'
      || formStatus === 'completed'
    );
  };

  useEffect(() => {
    if (programId != undefined && programId != '') {
      getSuggestedCoach(programId);
    }
  }, []);

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {memberName != undefined && memberName != '' && (
        <TextField
          name="current_member"
          label={(
            <>
              <span>Member</span>
              <abbr title="required">*</abbr>
            </>
          )}
          readOnly
        />
      )}
      {coachName != undefined && coachName != '' && (
        <TextField
          name="current_coach"
          label={(
            <>
              <span>Coach</span>
              <abbr title="required">*</abbr>
            </>
          )}
          readOnly
        />
      )}
      {programName != undefined && programName != '' && (
        <TextField
          name="program_name"
          label={(
            <>
              <span>Program</span>
              <abbr title="required">*</abbr>
            </>
          )}
          readOnly
        />
      )}
      {workType == 'CoachChangeCoach' && (
        <TextField
          name="member_name_all"
          label={(
            <>
              <span>Member</span>
              <abbr title="required">*</abbr>
            </>
          )}
          readOnly
        />
      )}
      {workType == 'AdminChangeMember' && workMode == 'create' && (
        <>
          <SelectField
            name="members"
            label={(
              <>
                <span>Member</span>
                <abbr title="required">*</abbr>
              </>
            )}
            placeholder="Type 3 chars or more for seach..."
            options={members}
            onInputChange={(value) => memberSearch(value)}
            onCustomonChange={(option) => {
              programSearch(option == null ? null : option.value);
            }}
          />

          <SelectField
            ref={programSelect}
            name="programs"
            label={(
              <>
                <span>Program</span>
                <abbr title="required">*</abbr>
              </>
            )}
            placeholder="Choose Program..."
            options={programs}
            onCustomonChange={(option) => {
              suggestedCoachSearch(option == null ? null : option.value);
            }}
          />
        </>
      )}

      {workType == 'AdminChangeCoach' && workMode == 'create' && (
        <SelectField
          name="coach"
          label={(
            <>
              <span>Coach</span>
              <abbr title="required">*</abbr>
            </>
            )}
          placeholder="Type 3 chars or more for seach..."
          options={coaches}
          onInputChange={(value) => coachSearch(value)}
        />
      )}

      <TextAreaField
        name="description"
        label={(
          <>
            <span>Reason</span>
            <abbr title="required">*</abbr>
          </>
        )}
        readOnly={blockField()}
        rows="5"
      />

      {workType == 'AdminChangeMember' && (
        <SelectField
          ref={suggestedCoachSelect}
          name="suggest_coach"
          label="Suggested New Coach"
          placeholder="Choose Suggested Coach..."
          value={formSuggestValue}
          options={suggestCoaches}
          maxMenuHeight={130}
          onCustomonChange={(value) => setFormSuggestValue(value)}
          isDisabled={blockField()}
        />
      )}

      <div className="text-center mt50 mb30">
        <CancelPopupButton title="Cancel" onClick={closeForm} />
        <SubmitButton
          title="Send"
          className={
            blockField()
              ? 'btn btn-gray btn-disabled not-possible-click'
              : 'btn width-100 btn-primary submit-button mr5 ml5'
          }
        />
      </div>
    </BaseForm>
  );
}
